import { fetchApi } from "./api";

export const searchProject = async (projectId, query, types = null) => {
  try {
    const params = new URLSearchParams();
    params.append("query", query);
    if (types && types.length > 0) {
      params.append("types", types.join(","));
    }

    const response = await fetchApi(`/api/search/${projectId}?${params.toString()}`, {
      method: "GET",
    });
    return response;
  } catch (error) {
    console.error("Search error:", error);
    throw error;
  }
};
